
const ENDPOINTS = {    
   COUNTRY:'/api/user/getAllCountry',
        ADMIN:{
            LOGIN: `/api/admin/auth/login` ,
            UPDATE_PROFILE:`/api/admin/auth/updateAdminProfile`,       
            FORGOT_PWD:`/api/admin/auth/forgotUserPassword`,
            GET_ADMIN_DETAILS:`/api/admin/auth/getAdminProfile`
         },
         DASHBOARD:{
            TOP_CARDS:`/api/admin/user/cardData`,
            GENDER_RATIO:`/api/admin/user/userGenderRatio`,
            JOINED_PER_MONTH: '/api/admin/user/userJoinedAsPerMonths', 
            SUBSCRIPTION_PER_MONTH: '/api/admin/subscription/getMonthlySubscriptionCount'
         },
         USER:{
            GET_USERS:`/api/admin/user/getAllUser`,
            USER_DETAIL:`/api/user/getUserById`,
            DEACTIVATE_TOGGLE:`api/admin/user/deactivateUser`,
            VERIFY_USER_TOGGLE:`/api/admin/user/manageVerification`,
            DELETE_USER:`/api/admin/user/deleteUser`,
            REPORTED_USERS:`/api/admin/report/getAllReports`,
            UPDATE_REPORT_STATUS:`/api/admin/report/updateReportStatus`
         },
         HOBBY:{
            GET_ALL_HOBBY:`/api/user/getAllHobbies`,
            ADD_CATEGORY:'/api/user/createHobbiesCategory',
            ADD_HOBBY:`/api/user/addHobbies`,
            DELETE_HOBBY:'/api/user/delHobby',
            DELETE_CATEGORY:'/api/user/delHobbyCategory'
         },
         FOUL_WORD:{
            GET_FOUL_WORDS:`/api/admin/foulWord/getFoulWordList`, 
            EDIT_FOUL_WORDS:`/api/admin/foulWord/editFoulWord`,
            IMPORVE_BY_AI:`/api/admin/foulWord/improveListByAI`,
            ADD_FOUL_WORDS:`/api/admin/foulWord/manageFoulWordList`,
            DELETE_FOUL_WORD:`/api/admin/foulWord/deleteFoulWord `
         },
         FAQ:{
            GET_ALL_FAQ:`/api/FAQ/getAllFAQsAdmin`,
            FAQ_STATUS:`/api/FAQ/manageFAQStatus`,
            ADD_FAQ:`/api/FAQ/addFAQ`,
            EDIT_FAQ:`/api/FAQ/editFAQ`,
            DELETE_FAQ:`/api/FAQ/deleteFAQ`
         },
        
     };

export { ENDPOINTS };
